import React from 'react';
import EntityForm from './EntityForm';

function ManageDepartmentForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Department"
            heading="Add New Department"
            idKey="DepartmentID"
            insertUrl="insert_manage_department"
            updateUrl="update_manage_department"
            deleteUrl="delete_manage_department"
            fields={[
                { name: 'name', label: 'Department Name', entryKey: 'Name', required: true },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageDepartmentForm;
